import { pickersDayClasses } from '@mui/x-date-pickers';
import { palette } from '../global/palette';
export const MuiPickersDay = {
    MuiPickersDay: {
        styleOverrides: {
            root: {
                borderRadius: 6,
                height: 28,
                '&:hover': {
                    backgroundColor: palette.grey[300],
                },
            },
            today: {
                backgroundColor: palette.info.light,
                color: palette.common.white,
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: palette.info.light,
                },
                [`&&.${pickersDayClasses.today}`]: {
                    border: 0,
                },
            },
        },
    },
};
